// Website related settings
const settings = {
  isSplash: true,
};

//SEO Related settings
const seo = {
  title: "José Valentín Portafolio",
  description:
    "Soy Ingeniero en Sistemas Computacionales graduado del TecNM Campus Oaxaca. Me encanta colaborar y trabajar en equipo. Si necesitas un compañero de código, ¡aquí estoy! Creo en el poder del trabajo en equipo y estoy emocionado por crear algo increíble contigo en el mundo del desarrollo.",
  og: {
    title: "José Valentín Portafolio",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "José Valentín",
  logo_name: "José Valentín",
  nickname: "",
  subTitle:
    "Soy Ingeniero en Sistemas Computacionales graduado del TecNM Campus Oaxaca. Me encanta colaborar y trabajar en equipo. Si necesitas un compañero de código, ¡aquí estoy! Creo en el poder del trabajo en equipo y estoy emocionado por crear algo increíble contigo en el mundo del desarrollo.",
  resumeLink: "CV-Zarate Carreño José Valentín.pdf",
  githubProfile: "https://github.com/JoseVale99",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/JoseVale99",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/jose-vaelntin-zc/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:valezarate.9903@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/ZarateCarreno",
    fontAwesomeIcon: "fa-x-twitter",
    backgroundColor: "#000000",
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/backup_python.dev/",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
];

const skills = {
  data: [
    {
      title: "Desarrollo Web",
      fileName: "FullStackImg",
      skills: [
        "🚀 Desarrollando el front-end de sitios web responsivos utilizando Angular, Vue.js, Bootstrap y CSS",
        "🛠️ Creando aplicaciones web con Python y Django, así como con Java y Spring Boot",
        "💻 Desarrollando aplicaciones web interactivas utilizando JavaScript, Angular y Vue.js",
        "🔧 Construyendo el back-end de aplicaciones con Python, Django, Java y Spring Boot",
        "🌐 Desarrollando aplicaciones web dinámicas con PHP y Laravel",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#553AAF",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Vue.js",
          fontAwesomeClassname: "simple-icons:vuedotjs",
          style: {
            color: "#4FC08D",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#0F0F11",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon-plain:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:springboot",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#FF2D20",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/JoseVale99",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/josevale999",
    },
    {
      siteName: "StackOverflow",
      iconifyClassname: "simple-icons:stackoverflow",
      style: {
        color: "#F48024",
      },
      profileLink:
        "https://stackoverflow.com/users/16702971/jos%C3%A9-valent%C3%ADn",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Instituto Tecnológico de Oaxaca - ITO | OAXACA",
      subtitle: "Ingeniería en Sistemas Computacionales",
      logo_path: "Instituto_Tecnologico_de_Oaxaca.png",
      alt_name: "Instituto Tecnológico de Oaxaca",
      duration: "2017 - 2022",
      descriptions: [
        "🖥️ Durante la carrera, estudié materias fundamentales como Estructuras de Datos, Algoritmos, Sistemas de Gestión de Bases de Datos, Sistemas Operativos, Arquitectura de Computadoras, entre otros.",
        "💼 La formación en Ingeniería en Sistemas Computacionales nos prepara para diseñar, implementar y administrar sistemas computacionales que respondan a las demandas del mundo actual.",
        "🎓 La carrera también abarca aspectos multidisciplinarios y sustentables para fomentar una visión estratégica y ética en nuestros proyectos.",
      ],
      website_link: "http://www.itoaxaca.edu.mx/",
    },
  ],
};

const certifications = {
  certifications: [
    /*     {
      title: "",
      subtitle: "",
      logo_path: "",
      certificate_link:
        "",
      alt_name: "",
      color_code: "#8C151599",
    }, */
  ],
};

// Experience Page
const experience = {
  title: "Experiencia",
  subtitle: "Trabajos y estudios",
  description: "Estos son algunos trabajos que he realizado.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Trabajos",
      work: true,
      experiences: [
        {
          title: "Desarrollador Web",
          company: "VisorUS",
          company_url: "https://sistemas.visorus.com.mx/",
          logo_path: "visous.png",
          duration: "Abril 2023 - Octubre 2023",
          location: "Oaxaca, México",
          description: [
            "Desarrollé mejoras para el sistema de gestión integral de la Guardia Civil en Tecámac, optimizando su estructura y funcionalidad para un rendimiento óptimo.",
            "Centralicé la gestión de usuarios y generé reportes del personal policial.",
            "Contribuí al desarrollo de la funcionalidad de alta de reportes de incidencia urbana en el sistema de 'Mejora y Gestión' del municipio de Tecámac.",
            "Implementé nuevas características para permitir a usuarios internos y ciudadanos realizar reportes de incidencias.",
            "Gestioné usuarios y clasifiqué reportes por categorías, mejorando así la eficiencia del sistema en su conjunto.",
            "Utilicé tecnologías como MySQL, Git y PHP, integradas en el Framework Laravel 6.",
          ],
        },
        {
          title: "Desarrollador Web",
          company: "IIDTEC",
          company_url: "",
          logo_path: "iidtec.png",
          duration: "Agosto 2022 - enero 2023",
          location: "Oaxaca, México",
          description: [
            "Desarrollo de una vibrante marketplace de productos regionales.",
            "Utilización de tecnologías como Laravel, PHP, MySQL y PayPal para la implementación.",
            "Creación e implementación de un sólido sistema de gestión de inventario de productos, permitiendo a los vendedores controlar el stock y actualizar la información de los productos.",
            "Desarrollo de un sistema de gestión de pedidos intuitivo y eficaz para la sección de compras, brindando a los clientes la capacidad de realizar pedidos, hacer seguimiento en tiempo real",
            "Integración de servicios de pago seguros como PayPal para garantizar transacciones sin problemas entre los clientes y los vendedores.",
          ],
          color: "#000000",
        },
      ],
    },
    {
      title: "Residencia Profesional",
      experiences: [
        {
          title: "Desarrollador Web",
          company: "IIDTEC",
          company_url: "",
          logo_path: "iidtec.png",
          duration: "Agosto 2022 - enero 2023",
          location: "Oaxaca, México",
          description: [
            "Desarrollo de una vibrante marketplace de productos regionales.",
            "Utilización de tecnologías como Laravel, PHP, MySQL y PayPal para la implementación.",
            "Creación e implementación de un sólido sistema de gestión de inventario de productos, permitiendo a los vendedores controlar el stock y actualizar la información de los productos.",
            "Desarrollo de un sistema de gestión de pedidos intuitivo y eficaz para la sección de compras, brindando a los clientes la capacidad de realizar pedidos, hacer seguimiento en tiempo real",
            "Integración de servicios de pago seguros como PayPal para garantizar transacciones sin problemas entre los clientes y los vendedores.",
          ],
          color: "#000000",
        },
      ],
    },
    /*     {
      title: "Voluntariado",
      experiences: [
        {
          title: "Voluntariado ejemplo titulo",
          company: "Google",
          company_url: "https://google.com/",
          logo_path: "google_logo.png",
          duration: "Marzo 2020 - Presente",
          location: "Mexico",
          description:[
          ],
          color: "#4285F4",
        },
      ],
    }, */
  ],
};

// Projects Page
const projectsHeader = {
  title: "Proyectos",
  description:
    "Estos son algunos de los proyectos en los que he estado involucrado.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      name: "Marketplace de Productos Regionales",
      description:
        "Mi plataforma de Marketplace de Productos Regionales es un escaparate digital donde la diversidad cultural y la autenticidad se encuentran. Diseñada y desarrollada desde cero, esta plataforma permite a los usuarios descubrir y adquirir una amplia gama de productos regionales, desde alimentos artesanales hasta artículos de decoración únicos. Con un enfoque en la experiencia del usuario, cada elemento de la interfaz se ha creado para facilitar la navegación y la compra, brindando una experiencia inmersiva que celebra la riqueza de nuestras comunidades locales.",
      url: "http://marketplaceoaxaca.66ghz.com/",
    },
    {
      name: "Bot de Noticias",
      description:
        "Descubre las últimas noticias del día con nuestro Bot de Telegram. Diseñado exclusivamente para México, este bot te brinda acceso rápido y fácil a noticias clasificadas por categorías. Mantente informado sobre lo que más te interesa de manera rápida y conveniente.",
      url: "https://t.me/newsMX_bot",
    },
    {
      name: "Bot Generador de QR",
      description:
        "¿Necesitas generar un código QR? ¡Este bot lo hace fácil! Simplemente proporciona una URL, texto, número de teléfono o incluso detalles de tu red WiFi, y nuestro bot generará un código QR personalizado al instante. Ya sea para compartir en línea o en impresiones físicas, simplifica tus necesidades de codificación con nuestro bot.",
      url: "https://t.me/Code_QR_bot",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contáctame",
    profile_image_path: "me.png",
    description:
      "Si tienes una pregunta o deseas contactarme, puedes hacerlo a través de cualquiera de las siguientes redes sociales.",
  },
  addressSection: {
    title: "Dirección",
    subtitle: "Santa Catarina Juquila, Oaxaca, México",
    locality: "Santa Catarina Juquila",
    country: "México",
    region: "Oaxaca",
    postalCode: "71900",
    streetAddress: "Barrio de la Asuncion, Portillo de la Luna S/N",
    avatar_image_path: "address_image.svg",
  },
  phoneSection: {
    title: "Teléfono",
    subtitle: "951-185-31-29",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  projects,
  contactPageData,
};
